module.exports = __webpack_public_path__ + "img/verified.e1d3e383.png";